import API from "./server.api.js";

export const isUnlock = `${API}/learning/checkUnlock`;
export const mark = `${API}/learning/markComplete`;